import { Dispatch } from 'redux';
import {
    appendToStreamedMessage,
    completeStreamedMessage,
    createChatSessionDispatch,
    updateSocketLoading,
    updateUserMessage
} from './chatAdvisorSlice.slice';
import { formatAdvisorResponseData } from './chatAdvisorStreamingService';
import { getValidTokenForChat } from '../../utils/chatTokenUtils';
import { getConversationRegionChatMetadata } from '../../utils/conversationRegionMetadata';

export type ChatSourceItem = { source_id: string; file_name: string };

export const sentRestApiMessage = async (
    apiUrl: string,
    message: string,
    senderId: string,
    advisorId: string,
    sources: ChatSourceItem[],
    mentions: any,
    token: string,
    dispatch: Dispatch,
    apiKey?: string,
    deepThinkMode = false,
    is_stream = true,
    isAuthenticated: boolean = true,
    fetchLatestGuestToken?: () => Promise<string | null | undefined>,
    sessionId?: string
) => {
    dispatch = sessionId ? createChatSessionDispatch(dispatch, sessionId) : dispatch;

    try {

        dispatch(updateSocketLoading(true));

        // Get a valid token (refresh if needed before making the API call)
        const validToken = await getValidTokenForChat(token, 300, dispatch, {
            isAuthenticated,
            fetchLatestGuestToken
        });

        const tokenToUse = validToken || token;

        const regionMetadata = getConversationRegionChatMetadata();

        const requestData = {
            advisor_id: advisorId,
            user_message: message ?? '',
            sender_id: senderId ?? "123456677888",
            metadata: {
                sources: sources ?? [],
                jwt: '',
                mentions: mentions ?? {},
                ...(regionMetadata ?? {}),
            },
            is_stream,
            token: tokenToUse,
            deep_think_mode: deepThinkMode,
            ...(apiKey && { 'x-api-key': apiKey })
        };

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json, text/event-stream',
                'Authorization': tokenToUse ? `Bearer ${tokenToUse}` : ''
            },
            body: JSON.stringify(requestData)
        };

        const response = await fetch(apiUrl, requestOptions);
        const result = await response.json();

        const advisorUIMessage: any = {
            isAdvisor: true,
            isUser: false,
        }

        try {
            const parsedResponse = JSON.parse(result?.response);
            parsedResponse.predictions.forEach((prediction: any) => {
                const currentResponse = {
                    intent_and_entities: parsedResponse.intent_and_entities,
                    predictions: [prediction],
                    ...(parsedResponse.is_ask !== undefined && { is_ask: parsedResponse.is_ask }),
                    ...(parsedResponse.clarifying_question_config && { clarifying_question_config: parsedResponse.clarifying_question_config }),
                    ...(parsedResponse.multi_select !== undefined && { multi_select: parsedResponse.multi_select })
                }
                const advisorUIMessage = formatAdvisorResponseData(JSON.stringify(currentResponse));
                dispatch(updateUserMessage(advisorUIMessage));
            })
        } catch (e) {
            advisorUIMessage.message = response.text;
            advisorUIMessage.aiResponseReceivedTime = Date.now().toString();
            dispatch(updateUserMessage(advisorUIMessage));
        }

        dispatch(updateSocketLoading(false));

    } catch (error) {
        dispatch(appendToStreamedMessage("\n\nI apologize, but there was an error processing your request. Please try again."));

        // Complete the message even on error
        const errorMessage = {
            isAdvisor: true,
            isUser: false,
            isStreaming: false,
            aiResponseReceivedTime: Date.now().toString(),
            metaData: [],
            isFeedbackAllowed: false
        };
        dispatch(completeStreamedMessage(errorMessage));
        dispatch(updateSocketLoading(false));
    }

    return null;
}
